import React, {useRef, useState} from 'react';
import ReactDOM from 'react-dom';

// Split an "On: ... Off: ..." help string into its two parts.
const parseOnOff = (raw, onL, offL) => {
    const marker = offL + ':';
    const idx = raw.indexOf(marker);
    let onPart = raw, off = '';
    if (idx > -1) {
        onPart = raw.slice(0, idx).trim();
        off = raw.slice(idx + marker.length).trim();
    }
    const on = onPart.replace(new RegExp('^\\s*' + onL + ':\\s*'), '').trim();
    return {on, off};
};

// Hover help icon. Renders via a portal with fixed positioning so it is never
// clipped by dialog/overflow boundaries. If the text contains the On/Off
// markers, it renders them on separate lines with colored keywords.
export const HelpIcon = ({text, onL, offL}) => {
    const ref = useRef(null);
    const [pos, setPos] = useState(null);
    if (!text) return null;

    const hasOnOff = onL && offL && text.indexOf(offL + ':') > -1;

    const enter = () => {
        const r = ref.current.getBoundingClientRect();
        const vw = window.innerWidth || 1000;
        const left = Math.min(Math.max(r.left + r.width / 2, 160), vw - 160);
        setPos({left, top: r.top});
    };
    const leave = () => setPos(null);

    let content = text;
    if (hasOnOff) {
        const {on, off} = parseOnOff(text, onL, offL);
        content = <>
            <div><span style={{color: '#4ade80', fontWeight: 700}}>{onL}:</span> {on}</div>
            {off && <div style={{marginTop: 4}}><span style={{color: '#f87171', fontWeight: 700}}>{offL}:</span> {off}</div>}
        </>;
    }

    return <>
        <i ref={ref} className="pi pi-info-circle" style={{color: '#9ca3af', cursor: 'help', fontSize: '0.9rem'}}
           onMouseEnter={enter} onMouseLeave={leave}/>
        {pos && ReactDOM.createPortal(
            <div style={{position: 'fixed', left: pos.left, top: pos.top,
                transform: 'translate(-50%, -100%) translateY(-8px)', background: '#374151', color: '#fff',
                padding: '8px 10px', borderRadius: 6, width: 300, fontSize: '.78rem', lineHeight: 1.45,
                zIndex: 2147483647, boxShadow: '0 2px 12px rgba(0,0,0,.3)', whiteSpace: 'normal', textAlign: 'left',
                pointerEvents: 'none'}}>
                {content}
            </div>, document.body)}
    </>;
};

export default HelpIcon;
